import React from 'react';
import './style.css';

const ImageOrText = props => {
  return (
    <div className="logo-box">
      <img
        src={props.image}
        alt={props.name}
        className="comparison-object-image"
      />

      <strong className="comparison-object-name">{props.name}</strong>
    </div>
  );
};

export default ImageOrText;



// WEBPACK FOOTER //
// ./src/comparison/components/Pair/imageortext.js